import axios from "axios";
import React, { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import {
    FaRegEye,
    FaBolt, 
    FaBan,
    FaTimes,
    FaCheck,
    FaClock
} from "react-icons/fa";
import { BACKEND } from "../../config/configEnvs";
import { FaSpinner } from "react-icons/fa";
import { FaPowerOff } from "react-icons/fa";
import Tooltip from "../ui/ToolTip";
import { MdOutlineCloudUpload, MdSchedule } from "react-icons/md";

const ItemRowServicioSeguimiento = ({ client }) => {
    
    return (
        <tr className="text-xs bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 transition-all duration-100">
            <th scope="row" className="px-6 py-2">
                <div className=" flex justify-start items-center gap-2">

                {client.activeServices > 0 ? (
                    <>
                        <Tooltip content={`La empresa tiene ${client.activeServices} servicio(s) contratado(s) en proceso`}>
                            <div className="hover:cursor-pointer">
                                <FaCheck className="text-green-500" /> 
                            </div> 
                        </Tooltip>
                    </>
                ) : client.toStartServices > 0 ? (
                    <>
                        <Tooltip content={`La empresa tiene ${client.toStartServices} servicio(s) "Por comenzar"`}>
                            <div className="hover:cursor-pointer">
                                <MdSchedule className="text-yellow-500" /> 
                            </div> 
                        </Tooltip>
                    </>
                ) : (
                    <Tooltip content={`La empresa no tiene servicios contratados en estado "En proceso" ni "Por comenzar"`}>
                        <div className="hover:cursor-pointer">
                            <FaTimes className="text-red-900" /> 
                        </div> 
                    </Tooltip>
                )}

                    <Link to={`/home/seguimiento/${client.brand?.id}`}>
                        <div className="p-2 text-blue-500 hover:bg-blue-600 hover:bg-opacity-25 rounded-md bg-blue-700 bg-opacity-10">
                            <FaRegEye className=" " />
                        </div>
                    </Link>
                </div>
            </th>

            <td scope="row" className="px-6 py-4 max-w-xs truncate text-center font-medium">
                {client.brand?.nombreComercial}
            </td>

            <td scope="row" className="px-6 py-4 max-w-xs text-center truncate">
                {client.brand?.ruc}
            </td>

            <td scope="row" className="px-6 py-4 text-center">
                <Tooltip
                    content={
                        <div>
                            <strong>Total Servicios:</strong> {client.totalServices}
                        </div>
                    }
                >
                    <>
                        {/* {client.activeServices + client.inactiveServices} */}
                        {client.totalServices}
                    </>
                </Tooltip>


            </td>

            <td scope="row" className="px-6 py-4 text-center">
                <div className="flex items-center justify-center h-full">
                    <span>{client.activeServices}</span>
                    <div className={`w-2 h-2 rounded-full ml-5 ${client.activeServices > 0 ? 'bg-green-500 animate-pulse' : 'bg-red-400'}`} />
                </div>
            </td>

            <td scope="row" className="px-6 py-4 text-center">
                <div className="flex items-center justify-center h-full">
                    <span>{client.inactiveServices}</span>
                </div>
            </td>

            <td scope="row" className="px-6 py-4 text-center">{client.brand?.nicho?.name}</td>
            <td scope="row" className="px-6 py-4 text-center">{client.brand?.nicho?.rubro?.name}</td>
        </tr>
    )
}

export default ItemRowServicioSeguimiento